import { unescape } from 'lodash';
import { APISettings } from '../../config/ApiSettings';
import { BaseAPI } from './baseApi';

const baseUrl = new APISettings().getApiURL();

class HearingNoticeApi<HearingNotice> extends BaseAPI {
    public getById: (id: number) => Promise<HearingNotice> = async (id: number) => {
        return (await BaseAPI.axios.get(`${baseUrl}/hearingNotice/${id}`)).data.output;
    };

    public getByFilingId: (filingId: number) => Promise<HearingNotice> = async (filingId: number) => {
        return (await BaseAPI.axios.get(`${baseUrl}/hearingNotice/GetByFilingId/${filingId}`)).data.output;
    };

    public create: (hearingNotice: HearingNotice) => Promise<HearingNotice> = async (hearingNotice: any) => {
        let encodedElectronicMeetingInfo = btoa(unescape(encodeURIComponent(hearingNotice.hearingEMeetingInfo ?? '')));

        hearingNotice.hearingEMeetingInfo = encodedElectronicMeetingInfo;

        return (await BaseAPI.axios.post(`${baseUrl}/hearingNotice`, hearingNotice)).data.output;
    };

    public update: (hearingNotice: HearingNotice) => Promise<HearingNotice> = async (hearingNotice: HearingNotice) => {
        return (await BaseAPI.axios.put(`${baseUrl}/hearingNotice`, hearingNotice)).data.output;
    };

    public delete: (id: number) => Promise<HearingNotice> = async (id: number) => {
        return (await BaseAPI.axios.delete(`${baseUrl}/hearingNotice/${id}`)).data.output;
    }
}

export const hearingNoticeApi = new HearingNoticeApi();